import { render, staticRenderFns } from "./CbsListAvatars.vue?vue&type=template&id=177a5454&scoped=true&"
import script from "./CbsListAvatars.vue?vue&type=script&lang=js&"
export * from "./CbsListAvatars.vue?vue&type=script&lang=js&"
import style0 from "./CbsListAvatars.vue?vue&type=style&index=0&id=177a5454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a5454",
  null
  
)

export default component.exports